// extracted by mini-css-extract-plugin
module.exports = {"ReactAppWrapper":"ReactAppWrapper_ReactAppWrapper__14U-9"};